<div class="modal-header modal_popup p-2 px-3 eMdlHdr">
  <h4 class="cardheading eMdlHdrClr mb-0 pt-0 pb-0">Upload Inspection Report</h4>
  <button type="button" class="close btn btn-light float-end eMdlClsBtn" (click)="actMdl.close()">
      <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body p-2">
  <div class="card">
      <div class="card-body p-2">
        <div class="row">
          <label for="">Upload <span><small class="text-danger">(The report should be in PDF format)</small></span>:</label>
          <input type="file" #fileInputRef class="form-control pt-2" (change)="changeFile($event)" accept=".pdf,.PDF"
            multiple />
          <ul class="list-group mt-2" *ngIf="filesToUpload?.length">
            <li class="list-group-item d-flex justify-content-between align-items-center"
              *ngFor="let file of filesToUpload; let i = index">
              <a [href]="file.previewUrl" target="_blank" rel="noopener">{{
                file.name
                }}</a>
              <button type="button" class="btn btn-sm btn-danger" (click)="removeFile(i)">
                Delete
              </button>
            </li>
          </ul>
        </div>
          
      </div>
  </div>
</div>
<div class="modal-footer">
  <div>
    <button type="button" class="btn btn-danger me-1" id="uploadModalCloseBtn" data-bs-dismiss="modal"
      (click)="closeUploadModal()">
      Close
    </button>
    <button class="btn btn-sm btn-save" (click)="uploadMultiple(approveData)">
      Submit
    </button>
  </div>
</div>

<!-- <div class="modal" tabindex="-1" id="uploadModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title"></h5>
        <button type="button" class="btn-close" (click)="closeUploadModal()" id="uploadModalCloseBtn"
          data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <label for="">Upload:</label>
          <input type="file" #fileInputRef class="form-control pt-2" (change)="changeFile($event)" accept=".pdf,.PDF"
            multiple />
          <ul class="list-group mt-2" *ngIf="filesToUpload?.length">
            <li class="list-group-item d-flex justify-content-between align-items-center"
              *ngFor="let file of filesToUpload; let i = index">
              <a [href]="file.previewUrl" target="_blank" rel="noopener">{{
                file.name
                }}</a>
              <button type="button" class="btn btn-sm btn-danger" (click)="removeFile(i)">
                Delete
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" id="uploadModalCloseBtn" data-bs-dismiss="modal"
          (click)="closeUploadModal()">
          Close
        </button>
        <button class="btn btn-sm btn-save" (click)="uploadMultiple(approveData)">
          Submit
        </button>
      </div>
    </div>
  </div>
</div> -->